// extracted by mini-css-extract-plugin
export default {"zeitraumPicker":"IWRangePicker_zeitraumPicker__FTgjE"};